import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const addLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "addSectionItem",
    src: "addSectionItem",
    onDone: [
      {
        // If "lesson_details" modal is closed, go to prev state.
        target: "#StudyPlan.edit_plan.go_back_to_previous",
        actions: "onAddLesson",
        cond: ctx => !ctx.lessonDetailViewModal
      },
      {
        // If "lesson_details" modal is open, refetch lesson details data.
        target: "#StudyPlan.edit_plan.lesson_detail_view",
        actions: "onAddLesson",
        cond: ctx => ctx.lessonDetailViewModal
      }
    ],
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("addSectionItem", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
